import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import "./PurchaseView.css"
import * as Icons from "heroicons-react";
import GRNprint from "../PrintReceipt/GRN/GRNprint";
import { useGrnQuery, useUpdateGrnMutation } from "../../../services/grnApi";

// import { ComponentToPrint } from './ComponentToPrint';

const GrnView = ({ show, handleClose, grn }) => {
  const componentRef = useRef();
  const grnView = useGrnQuery(grn);

  const [updateGrn] = useUpdateGrnMutation();

  // console.log(grnView.data);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const printRecipt = async () => {
    handlePrint();
    if (!grnView?.data?.print) {
      const updatePrint = await updateGrn({
        _id: grnView?.data?._id,
        print: true,
      });
      if (updatePrint) {
        console.log("print Orignal:", updatePrint);
      }
    }
  };
  // console.log(grn);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      className="responsive-modal"
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header
        className="d-flex justify-content-end justify-content-between align-items-center overflow-auto"
        closeButton
      >
        <Modal.Title>Goods Receive Note</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        <GRNprint ref={componentRef} grn={grnView.data} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <button className="btn btn-dark float-end" onClick={printRecipt}>
          <Icons.PrinterOutline className="ms-3" size={18} /> Print{" "}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default GrnView;
